<div class="edit-container">
    <div class="d-flex justify-content-between align-items-center mb-4">
        <h1 class="edit-title m-0 p-0">Actualizare drepturi acces Operator</h1>
        <button type="button" class="close" aria-label="Close" (click)="closeDialog()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="add-field">
        <h3>Servicii selectate: {{ serviciiIds.length }}</h3>
        <p>Servicii > Tipuri Cereri</p>
        <div class="row pb-3" *ngFor="let row of stateRows">
            <mat-expansion-panel [expanded]="row.cereri_types.length > 0" [disabled]="row.cereri_types.length === 0">
                <mat-expansion-panel-header class="group-header">
                    <mat-panel-title>
                        <mat-checkbox color="primary" [(ngModel)]="row.checked"
                            (click)="updateCheckedList(row, true); $event.stopPropagation()">
                            {{ row.label }}
                        </mat-checkbox>
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <div>
                    <div *ngFor="let cerere of row.cereri_types" class="checkbox ps-5">
                        <mat-checkbox color="primary" [(ngModel)]="cerere.checked" (click)="updateCheckedList(cerere)">
                            {{ cerere.name }}
                        </mat-checkbox>
                    </div>
                </div>
            </mat-expansion-panel>
        </div>
    </div>

    <div class="row">
        <div class="col d-flex justify-content-between">
            <button class="btn btn-light" type="button" mat-flat-button (click)="closeDialog()">
                {{ helper.dialogConfig.buttonLabels.close }}
            </button>
            <button class="btn btn-primary" type="button" mat-flat-button color="primary" [disabled]="isLoading"
                (click)="updateUtilizatori()">
                {{ helper.dialogConfig.buttonLabels.save }}
            </button>
        </div>
    </div>

    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>